"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = void 0;
/**
 * Форматирует номер телефона по маске "+7 (ххх) ххх-хх-хх"
 */
function formatPhoneNumber(value) {
    if (!value) {
        throw 'Wrong value in formatPhoneNumber';
    }
    var clearedPhone = value.replace(/(\+7)|^[+78 ]|\D/g, '');
    return "+7".concat(clearedPhone).replace(/^\+7(\d{3})(\d{3})(\d\d)(\d\d).*/, '+7 ($1) $2-$3-$4');
}
exports.formatPhoneNumber = formatPhoneNumber;
//# sourceMappingURL=formatPhoneNumber.js.map